
export class Features {
  issues: boolean;
  studyScapists: boolean;
}
